import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-norm',
  templateUrl: './norm.component.html',
  styleUrls: ['./norm.component.css']
})
export class NormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
